import CONSTANTS from '../constants';
import LoginService from './LoginService';

export default {
  getPaymentMethods,
  getPaymentProcessor,
  getPaymentStatuses,
  getPaymentContext,
  makePayment,
  generateOrderId,
  setPayment,
  getPayment,
  setup3ds,
  getOtpTrasnactionId,
  makePaymentXPay,
  retrievePaymentXPay,
  logPaymentXPay
};

async function setup3ds(processor, data) {
  const { token } = LoginService.getToken();
  let response = await fetch(
    `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.PAYMENTS.DEFAULT}/${processor.id}/setup`,
    {
      method: 'POST',
      body: JSON.stringify({ data }),
      headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
    }
  );

  let responseBody = await response.json();
  if (response.status === 200 && responseBody) return responseBody;
  throw new Error(responseBody.message);
}

async function getOtpTrasnactionId(processor, data) {
  const { token } = LoginService.getToken();
  let response = await fetch(
    `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.PAYMENTS.DEFAULT}/${processor.id}/otp`,
    {
      method: 'POST',
      body: JSON.stringify({ data }),
      headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
    }
  );

  let responseBody = await response.json();
  if (response.status === 200 && responseBody) return responseBody;
  throw new Error(responseBody.message);
}

async function makePayment(processor, currency, amount, orderId, data) {
  const { token } = LoginService.getToken();
  let response = await fetch(
    `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.PAYMENTS.DEFAULT}/${processor.id}`,
    {
      method: 'POST',
      body: JSON.stringify({ currency, amount, orderId, data }),
      headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
    }
  );

  let responseBody = await response.json();
  if (response.status === 200 && responseBody) return responseBody;
  throw new Error(responseBody.message);
}

function generateOrderId() {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
}

function setPayment(locationId, paymentResult) {
  localStorage.setItem(
    `${CONSTANTS.CACHE_KEY_PREFIX}_${locationId}_paymentResult`,
    JSON.stringify(paymentResult)
  );
}

function getPayment(locationId) {
  return JSON.parse(
    localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_${locationId}_paymentResult`)
  );
}

async function getPaymentMethods(processor) {
  const { token } = LoginService.getToken();
  let response = await fetch(
    `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.PAYMENTS.DEFAULT}/${processor.id}/payment_methods`,
    {
      method: 'POST',
      headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
    }
  );
  response = await response.json();
  if (response) return response;
  throw new Error('Could not make payment');
}

async function getPaymentProcessor(locationId) {
  let response = await fetch(
    `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.PAYMENTS.DEFAULT}/processor/${locationId}`,
    {
      method: 'POST',
      headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-SECRET': CONSTANTS.APP_SECRET }
    }
  );
  response = await response.json();
  if (response) return response;
  throw new Error('Could not get payment processor');
}

async function getPaymentStatuses() {
  const { token } = LoginService.getToken();
  let response = await fetch(
    `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.PAYMENTS.DEFAULT}/payment_statuses`,
    {
      method: 'GET',
      headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
    }
  );
  response = await response.json();
  if (response) return response;
  throw new Error('Could not get payment statuses');
}

async function getPaymentContext(processor) {
  const { token } = LoginService.getToken();
  let response = await fetch(
    `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.PAYMENTS.DEFAULT}/${processor.id}/payment_context`,
    {
      method: 'POST',
      headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
    }
  );
  response = await response.json();
  if (response && response.keyId) return response.keyId;
  throw new Error('Could not get payment context');
}

async function makePaymentXPay(orderData, processor) {
  const { token } = LoginService.getToken();
  let response = await fetch(
    `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.PAYMENTS.DEFAULT}/${processor.id}/xpay`,
    {
      method: 'POST',
      body: JSON.stringify(orderData),
      headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
    }
  );

  let responseBody = await response.json();
  if (response.status === 200 && responseBody) return responseBody;
  throw new Error(responseBody.message);
}

async function retrievePaymentXPay(processor, pi_id, order_id) {
  const { token } = LoginService.getToken();
  let response = await fetch(
    `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.PAYMENTS.DEFAULT}/${processor.id}/xpay/retrieve`,
    {
      method: 'POST',
      body: JSON.stringify({ pi_id, order_id }),
      headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
    }
  );

  let responseBody = await response.json();
  if (response.status === 200 && responseBody) return responseBody;
  throw new Error(responseBody.message);
}

async function logPaymentXPay(processor, pi_id, order_id, status, uniqId) {
  const { token } = LoginService.getToken();
  let response = await fetch(
    `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.PAYMENTS.DEFAULT}/${processor.id}/xpay/log`,
    {
      method: 'POST',
      body: JSON.stringify({ pi_id, order_id, status, uniqId }),
      headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
    }
  );

  let responseBody = await response.json();
  if (response.status === 200 && responseBody) return responseBody;
  throw new Error(responseBody.message);
}